import skillGreek from "../src/img/skillgreek.png"
import movieSearch from "../src/img/movie-search.png"
import memoryGame from "../src/img/memory-game.png"
import trekZen from "../src/img/Trekzen.jpeg"
import movieDB from "../src/img/movieDb.jpeg"
import foodieUi from "../src/img/foodieUi.jpg"
import foodieUiMob from "../src/img/foodieUiMob.png"
import gamingUi from "../src/img/gamingUi.png"
import gamingUi1 from "../src/img/gam-1.png"





export const products = [
  // {
  //   id: 1,
  //   img: `${skillGreek}`,
  //   link: "https://bhavin404.github.io/skill-greek/",
  // },
  
  // {
  //   id: 2,
  //   img: `${movieSearch}`,
  //   link: "https://bhavin404.github.io/movie-search-site/",
  // },
  {
    id: 2,
    img: `${movieDB}`,
    link: "https://moviedb-bhavin404.vercel.app/",
  },
  {
    id: 3,
    img: `${memoryGame}`,
    link: "https://enchanting-medovik-d99356.netlify.app/",
  },
  {
  id:4,
  img:`${trekZen}`,
  link:"https://trekzen.vercel.app/",
  }
  
];

export const designs =[
  {
    id:1,
    img:`${foodieUiMob}`,
    link:""
  },
  {
    id:2,
    img:`${foodieUi}`,
    link:""
  },
  {
    id:3,
    img:`${gamingUi1}`,
    link:""
  }
]
